import axios from "axios";
import { baseUrl, headers } from "../config/env";

// 대시보드
export function fetchDashboard(params) {
  return axios.get(baseUrl + `/admin/dashboard`, { params, headers });
}
export function fetchAvg(params) {
  return axios.get(baseUrl + `/admin/dashboard/avg`, { params, headers });
}

// 회원
export function fetchUserList(params) {
  return axios.get(baseUrl + `/admin/user/list`, { params, headers });
}

export function fetchUserDetails(id) {
  return axios.get(baseUrl + `/admin/user/${id}`, { headers });
}
export function fetchUserLogs(id) {
  return axios.get(baseUrl + `/admin/user/logs/${id}`, { headers });
}
export function fetchUserPayments(id) {
  return axios.get(baseUrl + `/admin/user/${id}/payments`, { headers });
}
export function updateUserDetails(data) {
  return axios.put(baseUrl + `/admin/user`, data, { headers });
}

export function removeUser(data) {
  return axios.post(baseUrl + `/admin/withdraw`, data, { headers });
}

// 진단 이력
export function fetchDiagnosisList(params) {
  return axios.get(baseUrl + `/admin/predict/list`, { params, headers });
}
// export function fetchDiagnosisDetails(id) {
//   return axios.get(baseUrl + `/admin/diagnosis/${id}`, { headers });
// }
// export function createDiagnosis(data) {
//   return axios.post(baseUrl + `/admin/diagnosis`, data, { headers });
// }
export function updateDiagnosis(id, data) {
  return axios.put(baseUrl + `/admin/diagnosis/${id}`, data, { headers });
}
export function removeDiagnosis(id) {
  return axios.delete(baseUrl + `/admin/diagnosis/${id}`, { headers });
}

// 단어
export function createWord(data) {
  return axios.post(baseUrl + `/admin/word`, data, { headers });
}
export function createWordBulk(data) {
  return axios.post(baseUrl + `/admin/word/bulk`, data, { headers });
}
export function updateWord(data) {
  return axios.put(baseUrl + `/admin/word`, data, { headers });
}
export function removeWord(id) {
  return axios.delete(baseUrl + `/admin/word/${id}`, { headers });
}
export function removeWordAll(data) {
  return axios.delete(baseUrl + `/admin/word/all`, { data, headers });
}
export function fetchWordList(params) {
  return axios.get(baseUrl + `/admin/word/list`, { params, headers });
}
export function fetchWord(id) {
  return axios.get(baseUrl + `/admin/word/${id}`, { headers });
}
export function fetchWordCategories() {
  return axios.get(baseUrl + `/admin/word/category/count`, { headers });
}

// 문장
export function createSentence(data) {
  return axios.post(baseUrl + `/admin/sentence`, data, { headers });
}
export function createSentenceBulk(data) {
  return axios.post(baseUrl + `/admin/sentence/bulk`, data, { headers });
}
export function updateSentence(data) {
  return axios.put(baseUrl + `/admin/sentence`, data, { headers });
}
export function removeSentence(id) {
  return axios.delete(baseUrl + `/admin/sentence/${id}`, { headers });
}
export function removeSentenceAll(data) {
  return axios.delete(baseUrl + `/admin/sentence/all`, { data, headers });
}
export function fetchSentenceList(params) {
  return axios.get(baseUrl + `/admin/sentence/list`, { params, headers });
}
export function fetchSentence(id) {
  return axios.get(baseUrl + `/admin/sentence/${id}`, { headers });
}
export function fetchSentenceCategories() {
  return axios.get(baseUrl + `/admin/sentence/category/count`, { headers });
}

// 리스닝
export function createListening(data) {
  return axios.post(baseUrl + `/admin/listening`, data, { headers });
}
export function createListeningBulk(data) {
  return axios.post(baseUrl + `/admin/listening/bulk`, data, { headers });
}
export function updateListening(data) {
  return axios.put(baseUrl + `/admin/listening`, data, { headers });
}
export function removeListening(id) {
  return axios.delete(baseUrl + `/admin/listening/${id}`, { headers });
}
export function removeListeningAll(data) {
  return axios.delete(baseUrl + `/admin/listening/all`, { data, headers });
}
export function fetchListeningList(params) {
  return axios.get(baseUrl + `/admin/listening/list`, { params, headers });
}
export function fetchListening(id) {
  return axios.get(baseUrl + `/admin/listening/${id}`, { headers });
}
export function fetchListeningCategories() {
  return axios.get(baseUrl + `/admin/listening/category/count`, { headers });
}

// 레벨 테스트
export function fetchLevelTestProblems(params) {
  return axios.get(baseUrl + `/admin/level-test/problems`, { params, headers });
}
export function fetchLevelTestProblem(id) {
  return axios.get(baseUrl + `/admin/level-test/problems/${id}`, { headers });
}
export function createLevelTestProblem(data) {
  return axios.post(baseUrl + `/admin/level-test/problems`, data, { headers });
}
export function createLevelTestProblemBulk(data) {
  return axios.post(baseUrl + `/admin/level-test/problems/bulk`, data, {
    headers,
  });
}
export function updateLevelTestProblem(id, data) {
  return axios.put(baseUrl + `/admin/level-test/problems/${id}`, data, {
    headers,
  });
}
export function removeLevelTestProblem(id) {
  return axios.delete(baseUrl + `/admin/level-test/problems/${id}`, {
    headers,
  });
}
export function removeLevelTestProblemsAll(data) {
  return axios.delete(baseUrl + `/admin/level-test/problems/all`, {
    data,
    headers,
  });
}

export function fetchLevelTestConfig() {
  return axios.get(baseUrl + `/admin/level-test/config`, { headers });
}
export function updateLevelTestConfig(data) {
  return axios.put(baseUrl + `/admin/level-test/config`, data, { headers });
}
export function fetchLevelTestSessions(params) {
  return axios.get(baseUrl + `/admin/level-test/sessions`, { params, headers });
}
export function fetchLevelTestSessionsByUser(userId, params) {
  return axios.get(baseUrl + `/admin/level-test/sessions/by-user/${userId}`, {
    params,
    headers,
  });
}
export function fetchLevelTestSession(id) {
  return axios.get(baseUrl + `/admin/level-test/sessions/${id}`, { headers });
}
export function finalizeLevelTestSession(id, data) {
  return axios.post(
    baseUrl + `/admin/level-test/sessions/${id}/finalize`,
    data,
    {
      headers,
    },
  );
}

// 비디오 학습
export function createVideo(data) {
  return axios.post(baseUrl + `/admin/video`, data, { headers });
}
export function updateVideo(data) {
  return axios.put(baseUrl + `/admin/video`, data, { headers });
}
export function removeVideo(id) {
  return axios.delete(baseUrl + `/admin/video/${id}`, { headers });
}
export function removeVideoAll(data) {
  return axios.delete(baseUrl + `/admin/video/all`, { data, headers });
}
export function fetchVideoList(params) {
  return axios.get(baseUrl + `/admin/video/list`, { params, headers });
}
export function fetchVideo(id) {
  return axios.get(baseUrl + `/admin/video/${id}`, { headers });
}
export function fetchvideoCategories() {
  return axios.get(baseUrl + `/admin/video/category/count`, { headers });
}

// 공지사항
export function createNotice(data) {
  return axios.post(baseUrl + `/admin/notice`, data, { headers });
}
export function updateNotice(data) {
  return axios.put(baseUrl + `/admin/notice`, data, { headers });
}
export function removeNotice(id) {
  return axios.delete(baseUrl + `/admin/notice/${id}`, { headers });
}
export function fetchNoticeList(params) {
  return axios.get(baseUrl + `/admin/notice/list`, { params, headers });
}
export function fetchNotice(id) {
  return axios.get(baseUrl + `/admin/notice/${id}`, { headers });
}

export function fetchAnalytics(params) {
  return axios.get(baseUrl + `/admin/analytics/user`, { params, headers });
}

// 회원
export function fetchFeedbackList(params) {
  return axios.get(baseUrl + `/admin/feedback/list`, { params, headers });
}

export function fetchFeedbackDetails(id) {
  return axios.get(baseUrl + `/admin/feedback/${id}`, { headers });
}

export function removeFeedback(id) {
  return axios.delete(baseUrl + `/admin/feedback/${id}`, { headers });
}
